import { useEffect, useState } from 'react';
import { useDebounceValue } from 'usehooks-ts';

import { DEBOUNCE_DELAY } from 'constants/debounce';

const MIN_SEARCH_LENGTH = 2;

// onDebouncedValueChanged is called during render — it MUST be memoized (e.g. wrapped in useCallback)
export const useDebouncedSearch = (
  value = '',
  { minLength = MIN_SEARCH_LENGTH, delay = DEBOUNCE_DELAY.DEFAULT, onDebouncedValueChanged } = {},
) => {
  const [debouncedValue, setDebouncedValue] = useDebounceValue(value, delay);
  const [prevDebouncedValue, setPrevDebouncedValue] = useState(debouncedValue);

  useEffect(() => {
    const trimmedValue = value.trimStart();
    const updatedValue = trimmedValue.length >= minLength ? trimmedValue : '';

    setDebouncedValue(updatedValue);
  }, [minLength, setDebouncedValue, value]);

  if (prevDebouncedValue !== debouncedValue) {
    setPrevDebouncedValue(debouncedValue);
    onDebouncedValueChanged?.();
  }

  return { debouncedValue };
};
